
<svg class="animate-spin" :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M17.7502 2.04065L16.2502 4.63872C12.1847 2.29151 6.98617 3.68445 4.63896 7.74994C2.29175 11.8154 3.68469 17.0139 7.75018 19.3612C11.8157 21.7084 17.0142 20.3154 19.3614 16.2499L21.9595 17.7499C18.7838 23.2503 11.7505 25.1349 6.25018 21.9592C0.749814 18.7836 -1.13475 11.7503 2.04089 6.24994C5.21653 0.749575 12.2498 -1.13499 17.7502 2.04065Z"
    fill="#FF0064"
  />
</svg>
